import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import AdminNewsForm from "./AdminNewsForm";
import AdminNewsEdit from "./AdminNewsEdit";

// State
import { addRoute } from "../../../store/actions/route";
import { setpageTitle } from "../../../store/actions/siteInfo";

class AdminNews extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);

		if (props.match.path === "/admin/news/add") {
			this.props.setpageTitle("Add News");
		} else {
			this.props.setpageTitle("Edit News");
		}
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<Switch>
				<Route path={"/admin/news/add"} exact component={AdminNewsForm} />
				<Route path={"/admin/news/edit"} component={AdminNewsEdit} />
				<Route path={"/admin/news"} component={AdminNewsEdit} />
			</Switch>
		);
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminNews);



// WEBPACK FOOTER //
// ./src/components/admin/news/AdminNews.js